export const AUTH_TOKEN_NAME = 'token';
